import { TranslateService } from '@ngx-translate/core';

/**
 * ST-2683: IoTEmeter checks saved since ST-2537 hold warning codes (voltage_a_missing_warning),
 * while older checks hold the text the app posted (Wiring Mode Not Set), which has no code to
 * look up and is shown as it is. The Connectivity Verification pages use the IoTEmeter wording
 * where it differs from the shared warnings names, which IoTAh and the Quick View also use.
 */
export function iotemeterWarningLabel(translate: TranslateService, warning: string): string {
	for (const key of [`connectivity_verification.iotemeter_warnings.${warning}`, `warnings.${warning}`]) {
		const label = translate.instant(key);
		if (typeof label == 'string' && label !== key)
			return label;
	}

	return warning;
}
